declare var Highcharts: any;
import {
    Component,
    Input,
    ElementRef,
    OnInit,
    AfterViewInit,
    OnDestroy,
    ViewChild
} from '@angular/core';
import {merge} from 'lodash';



@Component({
  selector: 'app-display-eia-highchart',
  templateUrl: './display-eia-highchart.component.html'
})
export class DisplayEiaHighchartComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() inputChart;
  @Input() chartId;
  //chart: any;
  elementId = 'chart-';
  _chart: any;
  @ViewChild('chart') public chartEl: ElementRef;


  constructor() { }


  ngOnInit() {
    this.elementId += this.chartId;
  }

  public ngAfterViewInit(){
    if (this.chartEl && this.chartEl.nativeElement) {

      this.inputChart.chart = merge({}, this.inputChart.chart, {
        renderTo: this.chartEl.nativeElement
      });
      this._chart = new Highcharts.Chart(this.inputChart);
    }
    
  }

  ngOnDestroy() {
    this._chart.destroy();
  }

}



// WEBPACK FOOTER //
// ./src/app/share-modules/eia-charts/display-eia-highchart/display-eia-highchart.component.ts